
import { useEffect, useState } from "react";
import { Box, Button, Container, MenuItem, Typography, useMediaQuery, TextField} from "@mui/material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { Diversity3 } from "@mui/icons-material";
import ReusableDialog from "../../CommanComponents/ReusableDialog";
import { useNavigate } from "react-router-dom";
import { callPostApi } from "../../API/ApiCallFunction";
import GradientLoader from "../../CommanComponents/GradientLoader";

export function TotalPlusCustomer() {

  const isMobile = useMediaQuery("(max-width:768px)");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [datar, setDatar] = useState([]);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [filterCtype, setFilterCtype] = useState('');
  const uniqueCTypes = [...new Set(datar.map(r => r.ctype))];
  const filteredRows = datar.filter(row => filterCtype ? row.ctype === filterCtype : true );
  const handleClose = () => setOpen(false);
 
  const customerListApi = async () => {
    try {
        setLoading(true);
        const storeid = user.store_info?.store_id;
        const payload = { mod: "CASHI_PLUS_CUSTOMER", data_arr: { store_id: storeid, start: 0, limit: 1000, }, };
        const apiResult = await callPostApi("cashi-customer", payload);
        if (apiResult.status === "200" && Array.isArray(apiResult.data)) {
          const formattedData = apiResult.data.map((item, index) => ({
            id:  index+1,
            cname: item.customer_name || "NA",
            contact: item.customer_mobile || "NA",
            customer_email: item.customer_email || "NA",
            ctype: item.cust_type || "NA",
            email: item.customer_email || "NA",
          }));
          setDatar(formattedData);
         
        } else {
          setDatar([]);
         }
      } finally {
        setLoading(false);
      }
    };
  

   useEffect(() => {
      customerListApi();
    }, []);
  const columns = [  
        { field: 'id', headerName: 'Sr no.', flex: isMobile ? undefined : 0.5},
        { field: 'cname', headerName: 'Customer Name',  flex: isMobile ? undefined : 1,},
        { field: 'ctype', headerName: 'Customer Type',  flex: isMobile ? undefined : 1,},
        { field: 'contact', headerName: 'Customer Contact', flex: isMobile ? undefined : 1,},
        { field: 'customer_email', headerName: 'Customer Email', flex: isMobile ? undefined : 1.5,},
        ]
  
  return (
    <Container sx={{ my: 2 }}>

      <Box sx={{ display: "flex", justifyContent: "start", mb: 2 }}>
        <Button  variant="contained"  sx={{ backgroundColor: "#000000", color: "#ffffff" }}
          onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>

      <Typography ariant="h6"  gutterBottom
        sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)",  p: 1, color: "#ffffff",
          borderRadius: "4px", mb: 3, display: "flex", alignItems: "center",}} >
        <Diversity3 sx={{ mr: 1 }} />Total Customer
      </Typography>
      
      {/* Filter */}
      <Box sx={{ display: 'flex', flexWrap:'wrap', gap: 2, mb: 2 }}>
        <TextField select label="Customer Type" value={filterCtype} onChange={e => setFilterCtype(e.target.value)} sx={{ minWidth: 180 }} >
           <MenuItem value="">All</MenuItem>
           {uniqueCTypes.map(ctype => ( <MenuItem key={ctype} value={ctype}>{ctype}</MenuItem> ))}
        </TextField>

        <Button variant="outlined"  color="error" sx={{ height: 56 }} onClick={() => setFilterCtype('')}>
         Clear Filter
        </Button>
      </Box> 

      {/* DataGrid */}
      <Box sx={{ height: "auto", width: "100%", mb: 4 }}>
        <DataGrid rows={filteredRows} columns={columns} showToolbar disableRowSelectionOnClick getRowHeight={() => "auto"}
          initialState={{ pagination: { paginationModel: { pageSize: 10 },}, }} pageSizeOptions={[10, 25, 50]}
          sx={{
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal",
              wordBreak: "break-word",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f0f0f0",
              color: "#000",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: 14,
              fontWeight: 600,
              whiteSpace: "normal",
              wordBreak: "break-word",
            },
          }}    
        />
      </Box>

      {/* Add Campaign Dialog */}
      <ReusableDialog open={open} onClose={handleClose} />
     {loading && <GradientLoader text="Loading" />}
      {/* Detail Dialog */}
     
    </Container>
  );
}
